import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import usePagination from '../../hooks/usePagination'
import { postDetails } from '../../services/http/http.service'
import { hideLoader, showLoader } from '../../store/Loader/loader.slice'
import { setPageData, setPageNumber } from '../../store/pageData/pageData.slice'
import { setOrderTab } from '../../store/selectedAPIs/selectedAPIs.slice'
import { useAppDispatch, useAppSelector } from '../../store/storeRequests'
import APIList from '../../utils/constants/APIList'
import formatDate from '../../utils/constants/formatDate'
import { APIResponseCodes } from '../../utils/constants/keys.constants'
import StoreSelectors from '../../utils/constants/StoreSelectors.constants'
import Card from '../Cards/Card'
import CustomPagination from '../CustomPagination/CustomPagination'
import './orders.css'
import { NavList } from '../../utils/constants/navigation'
import { message } from '../../utils/constants/Messages'

const Orders = () => {

  const isUIMounted = useRef(false)
  const dispatch = useAppDispatch()
  const location = useLocation()

  const { pageData } = useAppSelector(StoreSelectors.PAGE_STATE)
  const { access } = useAppSelector(StoreSelectors.USER_STATE)
  const [currentTabOption, setCurrentTabOption] = useState('uat')

  const { orderTabOption } = useAppSelector(StoreSelectors.SELECTED_STATE)

  const { currentItems, handlePageClick, itemsPerPage, pageNumber } = usePagination({
    items: currentTabOption === 'uat' ?
      typeof pageData.groupList === 'undefined' ? [] : pageData.groupList
      :
      typeof pageData.resApiList === 'undefined' ? [] : pageData.resApiList,
    perPageResults: 10,
    from: currentTabOption === 'uat' ? 'uatorders' : 'prodorders'
  })

  const getOrdersData = async (tab: 'uat' | 'prod') => {
    dispatch(showLoader(message.GETTING_ORDER_DATA))
    if (access.hasUATAccess && tab === 'uat') {
      const payload = {
        page_no: isUIMounted.current ? pageNumber + 1 : 1
      }
      const response =
        await postDetails(APIList.GET_ALL_ORDERS, payload, () => getOrdersData(tab))

      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data))
      }
    }

    if (access.hasProdAccess && tab === 'prod') {
      const payload = {
        page_no: isUIMounted.current ? pageNumber + 1 : 1
      }
      const response =
        await postDetails(APIList.GET_ALL_PROD_ORDERS, payload, () => getOrdersData(tab))

      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data))
      }
    }
    dispatch(hideLoader())

  }

  useEffect(() => {

    if (access.hasUATAccess || access.hasProdAccess) {
      isUIMounted.current = false
    }

    if (access.hasUATAccess || access.hasProdAccess) {
      setCurrentTabOption(orderTabOption)
      dispatch(setPageNumber(0))
      orderTabOption === 'uat' ? getOrdersData('uat') : getOrdersData('prod')
    }

    isUIMounted.current = true

  }, [orderTabOption, access])


  /** Handle tab click */
  const changeTab = (tab: 'uat' | 'prod') => {
    dispatch(setPageData([]))
    dispatch(setOrderTab(tab))
    setCurrentTabOption(tab)
    getOrdersData(tab)

  }
  return (
    <div className="mb-5">
      <div className="orders-container scrollTo">
        <div className="orders-header-action-container mb-3">

          <h2 className='text-capitalize mf-active-header'>{!location.pathname.includes(NavList.USER_PROFILE) ? 'Order Summary' : ''}</h2>
          <div className="orders-prod-toggle mb-2">
            <button
              onClick={() => changeTab('uat')}
              data-selected={currentTabOption === "uat"}
              className="prod-toggle-prod border-0 font-14 text-capitalize weight-500"
            >
              UAT
            </button>
            <button
              onClick={() => changeTab('prod')}
              data-selected={currentTabOption === "prod"}
              className="prod-toggle-live border-0 font-14 text-capitalize weight-500"
            >
              Production
            </button>
          </div>
        </div>
        {
          currentTabOption === 'uat' ?
            currentItems.length !== 0 ?
              currentItems.map((order: any, index: any) => (
                <div key={index}>
                  {new Date(order.created_at).getUTCDate() !== new Date(currentItems[index - 1]?.created_at).getUTCDate() &&
                    <p className='order-timestamp font-14 weight-500'>{formatDate(order.created_at, 'fullmonth')}</p>
                  }
                  <Card from='orders' list={[order]} source='uat-orders' />
                </div>
              ))
              :
              <div className="text-center py-3 no-data-with-view">
                <p className="mb-0 weight-500 font-14 text-primary-color mb-2">No data found...</p>
              </div>
            :
            currentItems.length !== 0 ?
              currentItems.map((order: any, index: any) => (
                <div key={index}>
                  {new Date(order.created_at).getUTCDate() !== new Date(currentItems[index - 1]?.created_at).getUTCDate() &&
                    <p className='order-timestamp font-14 weight-500'>{formatDate(order.created_at, 'fullmonth')}</p>
                  }
                  <Card from='orders' list={[order]} source='prod-orders' />
                </div>
              ))
              :
              <div className="text-center py-3 no-data-with-view">
                <p className="mb-0 weight-500 font-14 text-primary-color mb-2">No orders data found...</p>
              </div>
        }
      </div>
      {
        (typeof pageData?.total_pages !== 'undefined' && pageData?.total_pages > 1) &&
        <CustomPagination itemsPerPage={itemsPerPage} handlePageClick={handlePageClick} pageCount={pageData?.total_pages} pageNumber={pageNumber - 1} />
      }
    </div>
  )
}

export default Orders
